
import './CompteClient.scss';

//import Checkbox from '@mui/material/Checkbox';
import { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useUtilities from '../../../hooks/useUtilities';
import useWindowSize from '../../../hooks/useWindowSize';
//import { createTheme,ThemeProvider,  } from '@mui/material/styles';
//import { DrawStep3ClientIcone } from '../../../data/SVGs';
import { SideBarNavigationFicheExpert } from '../../../Styles/componentStyles';
import PrestationComplementaire from '../../Client/ProfileEntreprise/PrestationComplementaire';
import SideBar from './SideBarGestionClient';

//import { SideBarNavigationFicheExpert } from '../../../Styles/componentStyles';
function CompteClientPrestationComplementaireById() {

    const axiosPrivate = useAxiosPrivate();
    const { pathname } = useLocation();
    const currentPath = pathname.split('/').pop();
    const [nomEntreprise, setNomEntreprise] = useState('');
    const [nbrHrsHNOs,setNbrHrsHNOs] = useState(8);
    const [isMontant,setIsMontant] = useState('');

    const { setBackdropOpen } = useUtilities();
    const [checkUpdateValue, setCheckUpdateValue] = useState();
    const {device}=useWindowSize();
    let param = useParams();
    const navigate = useNavigate();
    const [inputListHNO, setInputListHNO] = useState([]);
    const [inputListAstreinte, setInputListAstreinte] = useState([]);
    const { i18n } = useTranslation();

    useEffect(() => {
        getPrestationComplementaire();
    }, []);

    const getPrestationComplementaire = async () => {
        try {
            setBackdropOpen(true);
            let endpoint = pathname.includes('gestionEsn') ? '/users/getEsnById/':'/users/getClientById/';
            const response = await axiosPrivate.get(endpoint + (param.ClientId ?? param.EsnId));
            setInputListAstreinte(response?.data?.prestationsComplementaires?.astreintes);
            setInputListHNO(response?.data?.prestationsComplementaires?.hnos);
            setNomEntreprise(response?.data?.profileEntreprise?.nom);
            if(response?.data?.prestationsComplementaires?.rules?.isMontant==false)
                setIsMontant('Coefficient');
            else
                setIsMontant('Montant');
            if(response?.data?.prestationsComplementaires?.rules?.nbrHrsHNOs)
                setNbrHrsHNOs(response?.data?.prestationsComplementaires?.rules?.nbrHrsHNOs);
            console.log('response.data', response?.data);
            setBackdropOpen(false);
            setCheckUpdateValue(true);

        } catch (error) {
            console.log(error);
            setBackdropOpen(false);
        }

    };

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', alignSelf: 'stretch', gap: '24px' }}>
                <div className='frame5Profile'>{location?.pathname?.includes('gestionEsn')  ? i18n.t('Gestion des Esn'):i18n.t('Gestion des Clients')} &gt; <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{nomEntreprise} </span> </div>
                <div style={{ display: 'flex', flexDirection: device=='desktop'?'row':'column', alignSelf: 'stretch', gap: '24px' }}>
                    <SideBar />
                    <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between',width:device=='desktop'?'85%':'100%',minWidth:device=='desktop'?'500px':'200px',alignItems: 'center',gap:'24px'}}>
                        <div
                            className='frame6CompteExpert'
                            style={{flexDirection:'row',width:'100%',flexWrap:'wrap'}}
                        >
                            <div
                                className='frame4CompteClient'
                                style={
                                    currentPath == 'CompteClient' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                                }
                            >
                                <p
                                    style={
                                        currentPath == 'CompteClient' ? SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                                    }
                                    onClick={() => {
                                        navigate('/' + ((pathname.split('/')).slice(1, -1)).join('/') + '/CompteClient', { replace: true });
                                    }}
                                >{i18n.t('Données Générales')}</p>
                            </div>
                            <div
                                className='frame5CompteClient'
                                style={
                                    currentPath == 'DonneeFacturation' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                                }
                            >
                                <p
                                    style={
                                        currentPath == 'DonneeFacturation' ? SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                                    }
                                    onClick={() => {
                                        navigate('/' + ((pathname.split('/')).slice(1, -1)).join('/') + '/DonneeFacturation', { replace: true });
                                    }}
                                >{i18n.t('Données Facturation')}</p>
                            </div>
                            <div
                                className='frame5CompteClient'
                                style={
                                    currentPath == 'PrestationComplementaire' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                                }
                            >
                                <p
                                    style={
                                        currentPath == 'PrestationComplementaire' ?
                                            SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                                    }
                                    onClick={() => {
                                        if (currentPath == 'PrestationComplementaire')
                                            navigate('.');
                                        else
                                            navigate('/' + ((pathname.split('/')).slice(1, -1)).join('/') + '/PrestationComplementaire', { replace: true });
                                    }}
                                >{i18n.t('Prestation Complémentaire')}</p>
                            </div>
                        </div>
                        <PrestationComplementaire
                            inputListHNO={inputListHNO}
                            setInputListHNO={setInputListHNO}
                            nbrHrsHNOs={nbrHrsHNOs}
                            setNbrHrsHNOs={setNbrHrsHNOs}
                            isMontant={isMontant}
                            setIsMontant={setIsMontant}
                            inputListAstreinte={inputListAstreinte}
                            setInputListAstreinte={setInputListAstreinte}
                            ClientId={(param.ClientId ?? param.EsnId)}
                            disabled={false}
                            checkUpdateValue={checkUpdateValue}
                            setCheckUpdateValue={setCheckUpdateValue}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
export default CompteClientPrestationComplementaireById;